import Contact from "../components/contact/contact"
function Contactpage(){
    return(
        <>
        <Contact/>
        </>
    )
}
export default Contactpage